module.exports = __webpack_public_path__ + "img/Telegram_icon.9dab1328.svg";